import { ProfileOutlined, TagsOutlined, TeamOutlined, UserAddOutlined, UsergroupAddOutlined, WalletOutlined, BellOutlined, BuildOutlined, DashboardOutlined, BankOutlined, UserOutlined, NotificationOutlined, ThunderboltOutlined, HomeOutlined, ExpandOutlined, FileTextOutlined, AppstoreOutlined, CalendarOutlined } from '@ant-design/icons'
import { displayMessage } from '../../helpers/messages'


export const sideMenuItensIconsStyle = {
  fontSize: 20,
}

export const topMenuItensIconsStyle = {
  fontSize: 20
}

export default
  {
    adminSideMenuItens: [
      {
        key: "/administrators",
        icon: <UserOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('ADMINISTRATOR_LIST'),
      },
      // {
      //   key: "/users",
      //   icon: <TeamOutlined style={sideMenuItensIconsStyle} />,
      //   title: displayMessage('USER_LIST'),
      // },
      {
        key: "/clients",
        icon: <BankOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('CLIENTS'),
      },
      {
        key: "/contents",
        icon: <NotificationOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('CONTENTS'),
      },
      {
        key: "/gym-workouts",
        icon: <ThunderboltOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('GYM_WORKOUTS'),
      },
      {
        key: "/home-workouts",
        icon: <HomeOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('HOME_WORKOUTS'),
      },
      {
        key: "/stretchings",
        icon: <ExpandOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('STRETCHINGS'),
      },
      {
        key: "/exercises",
        icon: <AppstoreOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('EXERCISE_CATALOG'),
      },
      {
        key: "/diets",
        icon: <FileTextOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('DIET_MANAGEMENT'),
      },

      {
        key: "/notifications",
        icon: <BellOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('NOTIFICATION_LIST'),
      },
      {
        key: "/scheduled-notifications",
        icon: <CalendarOutlined style={sideMenuItensIconsStyle} />,
        title: 'Notificações Agendadas',
      },
    ],
    userSideMenuItens: [
      {
        key: "/users",
        icon: <TeamOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('USER_LIST'),
      },
    ],
    topMenuItens: [
      {
        key: "/profile",
        icon: <UserOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('MY_PROFILE'),
      },
    ]
  }